




















































import Vue from 'vue'
import { BrandValue } from '@/search/types'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES, IMAGE_VARIANT_NAMES} from '@/common/constants'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    brandId: {
      type: Number,
      required: true
    },
    brands: {
      type: Array as () => BrandValue[],
      required: true
    }
  },
  data(): {
    isDesExpandable: boolean
    isDesExpanded: boolean
  } {
    return {
      isDesExpandable: false,
      isDesExpanded: false
    }
  },
  computed: {
    brand(): BrandValue | undefined {
      return this.brands.find(item => item.id === this.brandId)
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.BRAND_LOGO
    },
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    }
  },
  mounted() {
    const targetedEl = this.$refs.brandDescription as HTMLElement
    this.isDesExpandable = targetedEl
      ? targetedEl.offsetHeight < targetedEl.scrollHeight
      : false
  }
})
